import { useMutation } from 'react-query';

import { Order as OrderResponse, payNowResponse } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
  orderId: string,
  roomId?:string
};

export const retryPayment = ({ orderId, roomId }: requestDTO): Promise<OrderResponse> => {
  return axios.post(`parent/payment/retry/${orderId}`);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof retryPayment>;
};

export const useRetryPayment = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Payment updated successfully',
      });
    },
    ...config,
    mutationFn: retryPayment,
  });
};

export type payNowDTO = {
  appId: string,
  roomId?:string
};

export const payNow = ({ appId, roomId }: payNowDTO): Promise<payNowResponse> => {
  return axios.post(roomId ?`/parent/rooms/${roomId}/payment/new/${appId}` : `parent/payment/new/${appId}`);
};

type UseUpdateBusinessOptionss = {
  config?: MutationConfig<typeof payNow>;
};

export const usePayNow = ({ config }: UseUpdateBusinessOptionss = {}) => {
  return useMutation({
    onSuccess: () => {
      // showNotification({
      //   type: 'success',
      //   title: 'Payment updated successfully',
      // });
    },
    ...config,
    mutationFn: payNow,
  });
};

